import type {
  UpdateCustomerLabelsPayload,
  UpdateCustomerLabelsResponse,
  UpdateContractLabelsPayload,
  UpdateContractLabelsResponse,
} from '@vy/api-definition';
import {
  UpdateCustomerLabelsResponseSchema,
  UpdateContractLabelsResponseSchema,
} from '@vy/api-definition';
import { LABEL_ENTITY_TYPES } from '@vy/types';
import type { LabelEntityType } from '@vy/types';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../../services/api';

type UpdateEntityLabelsPayload = UpdateCustomerLabelsPayload | UpdateContractLabelsPayload;
type UpdateEntityLabelsResponse = UpdateCustomerLabelsResponse | UpdateContractLabelsResponse;

export function useUpdateEntityLabels(
  entityType: LabelEntityType,
  entityId: string,
  options?: UseMutationOptions<UpdateEntityLabelsResponse, unknown, UpdateEntityLabelsPayload>,
) {
  return useMutation(
    async (payload) => {
      const api = getPrivateApi();

      if (entityType === LABEL_ENTITY_TYPES.CUSTOMER) {
        const response = await api.updateCustomerLabels({
          customerId: entityId,
          updateCustomerLabelsRequest: payload,
        });
        return UpdateCustomerLabelsResponseSchema.parse(response);
      }

      const response = await api.updateContractLabels({
        contractId: entityId,
        updateContractLabelsRequest: payload,
      });
      return UpdateContractLabelsResponseSchema.parse(response);
    },
    options,
  );
}
